import { render, staticRenderFns } from "./edit-supervise-staff-modal.vue?vue&type=template&id=bf7004de&"
import script from "./edit-supervise-staff-modal.vue?vue&type=script&lang=js&"
export * from "./edit-supervise-staff-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-supervise-staff-modal.vue"
export default component.exports